import { RouteRecordRaw } from 'vue-router';

export const statics: Array<RouteRecordRaw> = [
    
    // docs
    {path: '/docs',         name: 'docs', component: () => import('@/page/docs/index.vue')},
    {path: '/docs/:id',     name: 'docpage', component: () => import('@/page/docs/index.vue')},
    
    // static
    {path: '/about',        name: 'about', component: () => import('@/page/about/index.vue')},
    {path: '/agreement',    name: 'agreement', component: () => import('@/page/docs/index.vue')},
    {path: '/privacy',      name: 'privacy', component: () => import('@/page/docs/index.vue')},
    {path: '/terms',        name: 'terms', component: () => import('@/page/docs/index.vue')},
    {path: '/users',         name: 'users', component: () => import('@/page/docs/index.vue')},
    {path: '/contact',      name: 'contact', component: () => import('@/page/docs/index.vue')},
    {path: '/ads',          name: 'ads', component: () => import('@/page/docs/index.vue')},
    {path: '/careers',      name: 'careers', component: () => import('@/page/docs/index.vue')},
    {path: '/cookie',       name: 'careers', component: () => import('@/page/docs/index.vue')},
  
]